import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import sglogo from "../../../assets/images/sglogo.png";
import {
  Navbar,
  Collapse,
  Typography,
  IconButton,
  List,
  ListItem,
} from "@material-tailwind/react";
import {
  Bars3Icon,
  XMarkIcon,
  HeartIcon,
  ShoppingCartIcon,
  UserCircleIcon,
  MagnifyingGlassIcon,
  UserIcon,
  Cog6ToothIcon,
  ArrowRightOnRectangleIcon,
  ChevronDownIcon,
  ClipboardDocumentListIcon,
} from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import apiService from "../../../services/api_services";
import auth_service from "../../../services/auth_service";
import { useCart } from "../../../context/CartContext";
import { useWishlist } from "../../../context/WishlistContext";
import { listenToProfileUpdates } from "../../../utils/profileEvents";

function NavList({ onLinkClick }) {
  return (
    <List className="mt-2 mb-2 p-0 lg:mt-0 lg:mb-0 lg:flex-row lg:p-1 lg:items-center">
      {/* Eyeglasses Route */}
      <Link
        to="/prodList"
        state={{
          message: "Eyeglasses",
          key: "ca_id",
          value: 10,
          table: "getallproduct",
        }}
        className="flex items-center group"
        onClick={onLinkClick}
      >
        <ListItem className="py-2 px-4 text-gray-800 font-semibold text-base lg:text-lg transition-all duration-300 group-hover:scale-105 group-hover:text-blue-600 group-hover:bg-blue-50 rounded-lg">
          Eyeglasses
        </ListItem>
      </Link>

      {/* Sunglasses Route */}
      <Link
        to="/prodList"
        state={{
          message: "Sunglasses",
          key: "ca_id",
          value: 2,
          table: "getallproduct",
        }}
        className="flex items-center group"
        onClick={onLinkClick}
      >
        <ListItem className="py-2 px-4 text-gray-800 font-semibold text-base lg:text-lg transition-all duration-300 group-hover:scale-105 group-hover:text-blue-600 group-hover:bg-blue-50 rounded-lg">
          Sunglasses
        </ListItem>
      </Link>

      {/* Contact Lenses Route */}
      <Link
        to="/prodList"
        state={{
          message: "Contact lenses",
          key: null,
          value: null,
          table: "getalllens",
        }}
        className="flex items-center group"
        onClick={onLinkClick}
      >
        <ListItem className="py-2 px-4 text-gray-800 font-semibold text-base lg:text-lg transition-all duration-300 group-hover:scale-105 group-hover:text-blue-600 group-hover:bg-blue-50 rounded-lg">
          Contact lenses
        </ListItem>
      </Link>

      {/* Genie Blu Route */}
      <Link
        to="/prodList"
        state={{
          message: "Genie Blu",
          key: "ca_id",
          value: 12,
          table: "getallproduct",
        }}
        className="flex items-center group"
        onClick={onLinkClick}
      >
        <ListItem className="py-2 px-4 text-gray-800 font-semibold text-base lg:text-lg transition-all duration-300 group-hover:scale-105 group-hover:text-blue-600 group-hover:bg-blue-50 rounded-lg">
          Genie Blu
        </ListItem>
      </Link>

      {/* Flash Sale Route */}
      <Link
        to="/prodList"
        state={{
          message: "Flash Sale",
          key: "on_sale",
          value: 1,
          table: "getallproduct",
        }}
        className="flex items-center group"
        onClick={onLinkClick}
      >
        <ListItem className="py-2 px-4 text-red-600 font-semibold text-base lg:text-lg transition-all duration-300 group-hover:scale-105 group-hover:text-red-700 group-hover:bg-red-50 rounded-lg border border-red-200">
          ⚡ Flash Sale
        </ListItem>
      </Link>
    </List>
  );
}

export function Header() {
  const navigate = useNavigate();
  const [openNav, setOpenNav] = React.useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = React.useState(false);
  const [userProfile, setUserProfile] = React.useState(null);
  const [profileLoading, setProfileLoading] = React.useState(false);
  const { cartCount, setCartCount } = useCart();
  const { wishlistCount } = useWishlist();

  let isLoggedIn = false;
  let customerId;
  let tokenData = null;

  try {
    tokenData = auth_service.getAccessTokenData();
    if (tokenData) {
      const { id, userName } = tokenData;
      isLoggedIn = true;
      customerId = id;
      console.log("Customer ID:", customerId);
      console.log("Username from token:", userName);
    }
  } catch (error) {
    console.log(error);
    isLoggedIn = false;
  }

  const fetchCartCount = async () => {
    if (isLoggedIn === false) {
      const localCart = JSON.parse(localStorage.getItem("cart")) || [];
      setCartCount(localCart.length);
    } else {
      try {
        const response = await apiService.fetchCartCountById(customerId);
        setCartCount(response.totalItems);
      } catch (error) {}
    }
  };

  const fetchUserProfile = async () => {
    if (isLoggedIn && customerId) {
      try {
        setProfileLoading(true);
        const response = await apiService.fetchProfileDetails(customerId);
        console.log("Profile API response:", response);
        if (response.success) {
          console.log("Profile data:", response.data);
          setUserProfile(response.data);
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
        // Set default profile data if fetch fails, but don't override with empty values
        // Let the component use token data as fallback
        setUserProfile(null);
      } finally {
        setProfileLoading(false);
      }
    }
  };

  const handleLogout = () => {
    Cookies.remove("accessToken");
    localStorage.removeItem("cart");
    localStorage.removeItem("wishlist");
    setUserProfile(null);
    navigate("/signin");
  };

  // Helper function to get the first word of the name
  const getFirstName = () => {
    if (userProfile?.first_name) {
      return userProfile.first_name.split(' ')[0];
    }
    if (tokenData?.userName) {
      return tokenData.userName.split(' ')[0];
    }
    return '';
  };

  // Helper function to get the first character of the name for avatar
  const getFirstCharacter = () => {
    if (userProfile?.first_name) {
      return userProfile.first_name.charAt(0).toUpperCase();
    }
    if (tokenData?.userName) {
      return tokenData.userName.charAt(0).toUpperCase();
    }
    return '';
  };

  useEffect(() => {
    fetchCartCount();
    if (isLoggedIn) {
      console.log("User is logged in, fetching profile for customer ID:", customerId);
      console.log("Token data available:", tokenData);
      fetchUserProfile();
    }
  }, [isLoggedIn]);

  // Add refresh mechanism for profile updates
  useEffect(() => {
    const handleProfileUpdate = (updatedUserData) => {
      if (isLoggedIn) {
        console.log("Profile update event received with data:", updatedUserData);
        console.log("Current userProfile before update:", userProfile);
        if (updatedUserData) {
          // Use the passed data directly for instant update
          setUserProfile(updatedUserData);
          console.log("UserProfile updated to:", updatedUserData);
        } else {
          // Fallback to API call if no data passed
          console.log("No data passed, fetching from API...");
          fetchUserProfile();
        }
      }
    };

    // Listen for profile update events using our utility function
    const cleanup = listenToProfileUpdates(handleProfileUpdate);
    
    return cleanup;
  }, [isLoggedIn]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showProfileDropdown && !event.target.closest('.profile-dropdown')) {
        setShowProfileDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showProfileDropdown]);

  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 960) {
        setOpenNav(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleProfileClick = () => {
    const accessToken = Cookies.get("accessToken");

    if (accessToken) {
      navigate("/profile");
    } else {
      navigate("/signin");
    }
  };

  return (
    <Navbar className="mx-auto px-2 lg:px-8 py-1 bg-white shadow-lg border-b border-gray-100 sticky top-0 z-50">
      <div className="flex items-center justify-between text-black">
        {/* Logo - Enhanced size and clarity */}
        <Typography
          as="a"
          href="/"
          variant="h6"
          className="ml-2 mr-4 cursor-pointer flex-shrink-0"
        >
          <img
            src={sglogo}
            alt="Logo"
            className="h-16 w-auto lg:h-24 object-contain filter brightness-110 contrast-110 transition-transform duration-300 hover:scale-105"
            style={{
              imageRendering: "crisp-edges",
              WebkitImageRendering: "crisp-edges",
              MozImageRendering: "crisp-edges",
            }}
          />
        </Typography>

        {/* Navigation Links - Desktop */}
        <div className="hidden lg:flex flex-grow justify-center">
          <NavList onLinkClick={() => {}} />
        </div>

        {/* Desktop Icons */}
        <div className="hidden gap-4 lg:gap-6 lg:flex items-center">
          <Link to="/searchEngine" className="group">
            <MagnifyingGlassIcon className="h-7 w-7 cursor-pointer text-gray-700 transition-all duration-300 group-hover:text-blue-600 group-hover:scale-110" />
          </Link>
          <Link to="/wishlist" className="hidden lg:flex group relative p-2">
            <div className="relative">
              <IconButton
                variant="text"
                className="text-gray-800 hover:bg-blue-50 p-2 rounded-full transition-all duration-300"
              >
                <HeartIcon className="h-6 w-6" />
              </IconButton>
              {wishlistCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                  {wishlistCount > 99 ? '99+' : wishlistCount}
                </span>
              )}
            </div>
          </Link>
          <Link to="/cart" className="hidden lg:flex group relative p-2">
            <div className="relative">
              <IconButton
                variant="text"
                className="text-gray-800 hover:bg-blue-50 p-2 rounded-full transition-all duration-300"
              >
                <ShoppingCartIcon className="h-6 w-6" />
              </IconButton>
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                  {cartCount > 99 ? '99+' : cartCount}
                </span>
              )}
            </div>
          </Link>
          {/* Profile Icon/Dropdown */}
          <div className="relative profile-dropdown">
            {isLoggedIn ? (
              <div className="relative">
                <button
                  onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                  className="flex items-center gap-2 p-2 rounded-lg hover:bg-gray-100 transition-colors duration-300"
                >
                  <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                    {getFirstCharacter() ? (
                      <span className="text-white font-semibold text-sm">
                        {getFirstCharacter()}
                      </span>
                    ) : (
                      <UserIcon className="h-5 w-5 text-white" />
                    )}
                  </div>
                  <div className="hidden lg:block text-left">
                    <div className="text-sm font-medium text-gray-900">
                      {getFirstName()}
                    </div>
                    <div className="text-xs text-gray-500">Welcome back</div>
                  </div>
                  <ChevronDownIcon className={`h-4 w-4 text-gray-500 transition-transform duration-200 ${showProfileDropdown ? 'rotate-180' : ''}`} />
                </button>

                {/* Dropdown Menu */}
                {showProfileDropdown && (
                  <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                    <div className="px-4 py-3 border-b border-gray-100">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                          {getFirstCharacter() ? (
                            <span className="text-white font-semibold text-lg">
                              {getFirstCharacter()}
                            </span>
                          ) : (
                            <UserIcon className="h-6 w-6 text-white" />
                          )}
                        </div>
                        <div>
                          <div className="font-medium text-gray-900">
                            {userProfile?.first_name && userProfile?.last_name 
                              ? `${userProfile.first_name} ${userProfile.last_name}`
                              : tokenData?.userName || 'User'
                            }
                          </div>
                          <div className="text-sm text-gray-500">
                            {userProfile?.email || ''}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="py-1">
                      <Link
                        to="/profile"
                        className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                        onClick={() => setShowProfileDropdown(false)}
                      >
                        <UserIcon className="h-4 w-4" />
                        My Profile
                      </Link>
                      {/* <Link
                        to="/profile?tab=Order%20History"
                        className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                        onClick={() => setShowProfileDropdown(false)}
                      >
                        <ClipboardDocumentListIcon className="h-4 w-4" />
                        Order History
                      </Link> */}
                      <Link
                        to="/profile?tab=Settings"
                        className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                        onClick={() => setShowProfileDropdown(false)}
                      >
                        <Cog6ToothIcon className="h-4 w-4" />
                        Settings
                      </Link>
                    </div>

                    <div className="border-t border-gray-100 py-1">
                      <button
                        onClick={handleLogout}
                        className="flex items-center gap-3 w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                      >
                        <ArrowRightOnRectangleIcon className="h-4 w-4" />
                        Sign Out
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <Link onClick={handleProfileClick} to="#" className="group">
                <div className="flex items-center gap-2 p-2 rounded-lg hover:bg-gray-100 transition-colors duration-300">
                  <UserCircleIcon className="h-7 w-7 cursor-pointer text-gray-700 transition-all duration-300 group-hover:text-blue-600 group-hover:scale-110" />
                  <span className="hidden lg:block text-sm font-medium text-gray-700 group-hover:text-blue-600">
                    Sign In
                  </span>
                </div>
              </Link>
            )}
          </div>
        </div>

        {/* Mobile Header - Only show menu button and profile */}
        <div className="flex items-center gap-3 lg:hidden">

          {/* User Profile for Mobile */}
          {isLoggedIn ? (
            <div className="relative profile-dropdown">
              <button
                onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                className="flex items-center gap-2 p-1 rounded-lg hover:bg-gray-100 transition-colors duration-300"
              >
                <div className="w-7 h-7 bg-blue-600 rounded-full flex items-center justify-center">
                  {getFirstCharacter() ? (
                    <span className="text-white font-semibold text-xs">
                      {getFirstCharacter()}
                    </span>
                  ) : (
                    <UserIcon className="h-4 w-4 text-white" />
                  )}
                </div>
              </button>

              {showProfileDropdown && (
                <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
                  <div className="p-4 border-b border-gray-200">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                        {getFirstCharacter() ? (
                          <span className="text-white font-semibold text-sm">
                            {getFirstCharacter()}
                          </span>
                        ) : (
                          <UserIcon className="h-5 w-5 text-white" />
                        )}
                      </div>
                      <div>
                        <div className="font-medium text-gray-900 text-sm">
                          {userProfile?.first_name && userProfile?.last_name 
                            ? `${userProfile.first_name} ${userProfile.last_name}`
                            : tokenData?.userName || 'User'
                          }
                        </div>
                        <div className="text-xs text-gray-500">
                          {userProfile?.email || ''}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="py-2">
                    <Link
                      to="/profile"
                      className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                      onClick={() => setShowProfileDropdown(false)}
                    >
                      <UserIcon className="h-4 w-4" />
                      My Profile
                    </Link>
                    {/* <Link
                      to="/profile?tab=Order%20History"
                      className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                      onClick={() => setShowProfileDropdown(false)}
                    >
                      <ClipboardDocumentListIcon className="h-4 w-4" />
                      Order History
                    </Link> */}
                    <button
                      onClick={() => {
                        handleLogout();
                        setShowProfileDropdown(false);
                      }}
                      className="flex items-center gap-3 px-4 py-2 text-sm text-red-600 hover:bg-red-50 w-full text-left"
                    >
                      <ArrowRightOnRectangleIcon className="h-4 w-4" />
                      Sign Out
                    </button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <Link onClick={handleProfileClick} to="#" className="group">
              <div className="flex items-center gap-1 p-1 rounded-lg hover:bg-gray-100 transition-colors duration-300">
                <UserCircleIcon className="h-7 w-7 cursor-pointer text-gray-700 transition-all duration-300 group-hover:text-blue-600 group-hover:scale-110" />
              </div>
            </Link>
          )}

          {/* Mobile Menu Button */}
          <IconButton
            variant="text"
            color="black"
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors duration-300 shrink-0"
            onClick={() => setOpenNav(!openNav)}
          >
            {openNav ? (
              <XMarkIcon className="h-6 w-6 transition-transform duration-300 rotate-180" />
            ) : (
              <Bars3Icon className="h-6 w-6 transition-transform duration-300" />
            )}
          </IconButton>
        </div>
      </div>

      {/* Mobile Menu */}
      <Collapse open={openNav} className="overflow-hidden">
        <div className="pt-1 pb-2">
          <NavList onLinkClick={() => setOpenNav(false)} />

          {/* Mobile Menu Icons */}
          <div className="flex flex-col gap-2 mt-2 pt-2 border-t border-gray-200">
            <Link
              to="/searchEngine"
              className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors duration-300"
              onClick={() => setOpenNav(false)}
            >
              <MagnifyingGlassIcon className="h-6 w-6 text-gray-600" />
              <span className="text-gray-800 font-semibold text-base">
                Search
              </span>
            </Link>

            <Link
              to="/wishlist"
              className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors duration-300"
              onClick={() => setOpenNav(false)}
            >
              <div className="relative">
                <HeartIcon className={`h-6 w-6 ${wishlistCount > 0 ? 'text-red-500 fill-red-500' : 'text-gray-600'}`} />
                {wishlistCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold min-w-[16px] h-4 flex items-center justify-center rounded-full px-1">
                    {wishlistCount > 99 ? "99+" : wishlistCount}
                  </span>
                )}
              </div>
              <span className="text-gray-800 font-semibold text-base">
                Wishlist {wishlistCount > 0 && `(${wishlistCount})`}
              </span>
            </Link>

            {/* Profile Section for Mobile */}
            {isLoggedIn ? (
              <div className="space-y-2">
                <div className="flex items-center gap-3 p-3 bg-blue-50 rounded-lg">
                  <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                    {getFirstCharacter() ? (
                      <span className="text-white font-semibold text-sm">
                        {getFirstCharacter()}
                      </span>
                    ) : (
                      <UserIcon className="h-5 w-5 text-white" />
                    )}
                  </div>
                  <div>
                    <div className="text-sm font-medium text-gray-900">
                      {userProfile?.first_name && userProfile?.last_name 
                        ? `${userProfile.first_name} ${userProfile.last_name}`
                        : tokenData?.userName || getFirstName() || 'User'
                      }
                    </div>
                    <div className="text-xs text-gray-500">
                      {userProfile?.email || 'Welcome back'}
                    </div>
                  </div>
                </div>
                
                <Link
                  to="/profile"
                  className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors duration-300"
                  onClick={() => setOpenNav(false)}
                >
                  <UserIcon className="h-6 w-6 text-gray-600" />
                  <span className="text-gray-800 font-semibold text-base">
                    My Profile
                  </span>
                </Link>
                
                {/* <Link
                  to="/profile?tab=Order%20History"
                  className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors duration-300"
                  onClick={() => setOpenNav(false)}
                >
                  <ClipboardDocumentListIcon className="h-6 w-6 text-gray-600" />
                  <span className="text-gray-800 font-semibold text-base">
                    Order History
                  </span>
                </Link> */}
                
                <button
                  onClick={() => {
                    handleLogout();
                    setOpenNav(false);
                  }}
                  className="flex items-center gap-3 p-3 rounded-lg hover:bg-red-50 transition-colors duration-300 w-full text-left"
                >
                  <ArrowRightOnRectangleIcon className="h-6 w-6 text-red-600" />
                  <span className="text-red-600 font-semibold text-base">
                    Sign Out
                  </span>
                </button>
              </div>
            ) : (
              <Link
                onClick={() => {
                  handleProfileClick();
                  setOpenNav(false);
                }}
                to="#"
                className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors duration-300"
              >
                <UserCircleIcon className="h-6 w-6 text-gray-600" />
                <span className="text-gray-800 font-semibold text-base">
                  Sign In
                </span>
              </Link>
            )}
          </div>
        </div>
      </Collapse>
    </Navbar>
  );
}

export default Header;